
export type Language = 'Dutch' | 'English' | 'German' | 'Polish' | 'French' | 'Turkish';
export const LanguageValues: Language[] = ['Dutch' , 'English' , 'German' , 'Polish' , 'French' , 'Turkish'];

